import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiCalendar, FiClock, FiArrowRight, FiSearch, FiUser, FiTag } from 'react-icons/fi';
import './PageStyles.css';
import './BlogPage.css';

const BlogPage: React.FC = () => {
  const { t } = useTranslation();

  const posts = [
    {
      id: 1,
      slug: '2025-eticaret-trendleri-yapay-zeka-kisisellestirilmis-alisveris',
      title: '2025 E-Ticaret Trendleri: Yapay Zeka ve Kişiselleştirilmiş Alışveriş Deneyimi',
      excerpt: '2025 yılında e-ticaret sektörünü şekillendirecek en önemli trendler: Yapay zeka destekli ürün önerileri, AR/VR ile sanal deneme, sesli alışveriş ve sürdürülebilir e-ticaret pratikleri.',
      content: 'E-ticaret dünyası hızla evrilmeye devam ediyor. 2025 yılında yapay zeka, artırılmış gerçeklik ve kişiselleştirme teknolojileri alışveriş deneyimini tamamen değiştirecek...',
      image: '🤖',
      category: 'E-Ticaret',
      tags: ['yapay zeka', 'e-ticaret', 'dijital dönüşüm', 'AR/VR'],
      author: 'Ahmet Yılmaz',
      date: '10 Aralık 2025',
      readTime: '8 dk'
    },
    {
      id: 2,
      slug: 'instagram-reels-algoritma-2025-viral-icerik-stratejileri',
      title: 'Instagram Reels Algoritması 2025: Viral İçerik Stratejileri ve Satış Artırma',
      excerpt: 'Instagram Reels algoritmasının 2025 güncellemeleri, viral içerik formülleri, en iyi paylaşım saatleri ve Reels ile e-ticaret entegrasyonu hakkında detaylı rehber.',
      content: 'Instagram Reels, markaların görünürlüğünü artırmak için en güçlü araçlardan biri olmaya devam ediyor...',
      image: '📱',
      category: 'Sosyal Medya',
      tags: ['instagram', 'reels', 'sosyal medya pazarlama', 'viral içerik'],
      author: 'Elif Demir',
      date: '8 Aralık 2025',
      readTime: '6 dk'
    },
    {
      id: 3,
      slug: 'tiktok-shop-turkiye-magaza-acma-rehberi-2025',
      title: 'TikTok Shop Türkiye: Mağaza Açma Rehberi ve Satış Stratejileri 2025',
      excerpt: 'TikTok Shop Türkiye\'de nasıl mağaza açılır? Komisyon oranları, ürün listeleme, canlı yayın satışı ve influencer işbirlikleri hakkında kapsamlı rehber.',
      content: 'TikTok Shop, sosyal ticaretin geleceğini temsil ediyor. Türkiye\'de de hızla büyüyen bu platform...',
      image: '🎵',
      category: 'E-Ticaret',
      tags: ['tiktok', 'tiktok shop', 'sosyal ticaret', 'canlı yayın satış'],
      author: 'Mehmet Kaya',
      date: '5 Aralık 2025',
      readTime: '10 dk'
    },
    {
      id: 4,
      slug: 'trendyol-hepsiburada-n11-pazaryeri-optimizasyonu',
      title: 'Trendyol, Hepsiburada, N11: Pazaryeri Optimizasyonu ve Satış Artırma Teknikleri',
      excerpt: 'Türkiye\'nin en büyük pazaryerlerinde mağaza optimizasyonu, SEO uyumlu ürün başlıkları, görsel standartları ve reklam stratejileri.',
      content: 'Pazaryerlerinde başarılı olmak için doğru optimizasyon teknikleri şart. Ürün başlıklarından görsellere...',
      image: '🛒',
      category: 'E-Ticaret',
      tags: ['trendyol', 'hepsiburada', 'n11', 'pazaryeri', 'e-ticaret seo'],
      author: 'Mehmet Kaya',
      date: '3 Aralık 2025',
      readTime: '12 dk'
    },
    {
      id: 5,
      slug: 'ugc-icerik-uretimi-marka-videolari-2025',
      title: 'UGC İçerik Üretimi: Markalar İçin Kullanıcı Kaynaklı Video Stratejileri',
      excerpt: 'User Generated Content (UGC) nedir? Markalar için UGC video üretim süreci, model seçimi, senaryo hazırlama ve dönüşüm oranlarını artırma taktikleri.',
      content: 'UGC içerikler, geleneksel reklamlardan 4 kat daha yüksek dönüşüm oranına sahip...',
      image: '🎬',
      category: 'Reklam',
      tags: ['ugc', 'video prodüksiyon', 'içerik pazarlama', 'influencer'],
      author: 'Zeynep Arslan',
      date: '1 Aralık 2025',
      readTime: '7 dk'
    },
    {
      id: 6,
      slug: 'linkedin-b2b-pazarlama-lead-generation-2025',
      title: 'LinkedIn B2B Pazarlama: Lead Generation ve Kurumsal Marka İnşası',
      excerpt: 'B2B şirketler için LinkedIn pazarlama stratejileri, Sales Navigator kullanımı, içerik planlaması ve kaliteli lead üretme teknikleri.',
      content: 'LinkedIn, B2B pazarlamada en güçlü platform olmaya devam ediyor. Doğru stratejiyle...',
      image: '💼',
      category: 'Sosyal Medya',
      tags: ['linkedin', 'b2b pazarlama', 'lead generation', 'kurumsal'],
      author: 'Ahmet Yılmaz',
      date: '28 Kasım 2025',
      readTime: '9 dk'
    },
    {
      id: 7,
      slug: 'amazon-turkiye-fba-magaza-acma-rehberi',
      title: 'Amazon Türkiye FBA: Mağaza Açma, Depolama ve Lojistik Rehberi',
      excerpt: 'Amazon Türkiye\'de FBA (Fulfillment by Amazon) ile satış yapmak, depolama maliyetleri, kargo süreçleri ve uluslararası satış fırsatları.',
      content: 'Amazon FBA, e-ticaret girişimcileri için lojistik yükünü minimize eden güçlü bir sistem...',
      image: '📦',
      category: 'E-Ticaret',
      tags: ['amazon', 'fba', 'e-ticaret', 'lojistik'],
      author: 'Mehmet Kaya',
      date: '25 Kasım 2025',
      readTime: '11 dk'
    },
    {
      id: 8,
      slug: 'dijital-reklam-butcesi-planlama-roi-hesaplama',
      title: 'Dijital Reklam Bütçesi Planlama: ROI Hesaplama ve Performans Optimizasyonu',
      excerpt: 'Meta Ads, Google Ads ve TikTok Ads için bütçe planlama, ROAS hedefleri belirleme, A/B test stratejileri ve reklam performans analizi.',
      content: 'Doğru bütçe planlaması, dijital reklamcılıkta başarının anahtarı. Her platformun kendine özgü dinamikleri...',
      image: '💰',
      category: 'Reklam',
      tags: ['dijital reklam', 'meta ads', 'google ads', 'roas', 'performans'],
      author: 'Elif Demir',
      date: '22 Kasım 2025',
      readTime: '8 dk'
    },
    {
      id: 9,
      slug: 'whatsapp-business-api-musteri-iletisimi',
      title: 'WhatsApp Business API: Otomatik Müşteri İletişimi ve Satış Botları',
      excerpt: 'WhatsApp Business API entegrasyonu, chatbot kurulumu, otomatik mesaj şablonları ve müşteri hizmetleri otomasyonu rehberi.',
      content: 'WhatsApp, dünyada en çok kullanılan mesajlaşma uygulaması. İşletmeler için WhatsApp Business API...',
      image: '💬',
      category: 'Dijital Pazarlama',
      tags: ['whatsapp', 'chatbot', 'müşteri hizmetleri', 'otomasyon'],
      author: 'Zeynep Arslan',
      date: '20 Kasım 2025',
      readTime: '6 dk'
    }
  ];

  const categories = ['Tümü', 'E-Ticaret', 'Sosyal Medya', 'Reklam', 'Dijital Pazarlama'];

  // SEO için document title güncelleme
  useEffect(() => {
    document.title = 'Blog | UstaConsulting - Dijital Pazarlama ve E-Ticaret Rehberleri';
  }, []);

  return (
    <div className="page-wrapper">
      <motion.div 
        className="page-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            {t('blog.title')}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            Dijital dünyada başarılı olmak için ihtiyacınız olan tüm bilgiler
          </motion.p>
        </div>
      </motion.div>

      <section className="blog-page-content section">
        <div className="container">
          <div className="blog-filters">
            <div className="search-box">
              <FiSearch />
              <input type="text" placeholder={t('blog.search')} />
            </div>
            <div className="category-filters">
              {categories.map((category, index) => (
                <button 
                  key={index} 
                  className={`category-btn ${index === 0 ? 'active' : ''}`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          <div className="blog-page-grid">
            {posts.map((post, index) => (
              <motion.article 
                key={post.id}
                className="blog-page-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ y: -8 }}
                itemScope
                itemType="https://schema.org/BlogPosting"
              >
                <div className="blog-page-image">
                  <span className="blog-page-emoji">{post.image}</span>
                  <span className="blog-page-category">{post.category}</span>
                </div>
                <div className="blog-page-card-content">
                  <div className="blog-page-meta">
                    <span><FiCalendar /> <time itemProp="datePublished">{post.date}</time></span>
                    <span><FiClock /> {post.readTime}</span>
                    <span><FiUser /> {post.author}</span>
                  </div>
                  <h2 className="blog-page-title" itemProp="headline">{post.title}</h2>
                  <p className="blog-page-excerpt" itemProp="description">{post.excerpt}</p>
                  <div className="blog-page-tags">
                    {post.tags.slice(0, 3).map((tag, idx) => (
                      <span key={idx} className="blog-tag">
                        <FiTag /> {tag}
                      </span>
                    ))}
                  </div>
                  <Link to={`/blog/${post.slug}`} className="blog-page-link" itemProp="url">
                    {t('blog.readMore')}
                    <FiArrowRight />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
